module.exports = __webpack_public_path__ + "media/images/matchdaySelector__md1--selected-5e942887568a78fab6b8339f943633d4.png";